module.exports = {
  "id": "dizzy",
  "icon": "dizzy",
  "color": "green",
  "title": "dizzy",
  "info": [
    {
      "text": "Make a piece spin in circles",
      "image": "provision/glitches/dizzy/dizzy.gif"
    }
  ],
  "category": "movement",
  "searchTags": ["spin","rotate","turn","cartwheel","twirl","swivel"],
  "exposedVariables": [
    {
      "tooltip":"Set how fast the stickered piece rotates",
      "value": 5,
      "variableName": "Dizzy Speed",
      "spriteName": "$glitch_target",
      "input": {
        "type": "slider",
        "min": -30,
        "max": 30
      }
    }
  ],
};